
let faqCate = document.querySelectorAll('.faqCate');
faqCate.forEach(el => {
    el.addEventListener('click', () => {
        el.closest('.faqWrap').classList.toggle('active');
    })
});

let faqShowSub = document.querySelectorAll('a[href="#faq__answer-content"]');
faqShowSub.forEach(el => {
    el.addEventListener('click', () => {
        el.closest('.faqA').classList.toggle('showSub');
    });
});
